// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background-color: rgba(0, 0, 0, 0.5); - 드래그 시 backdrop 클릭 방지를 위해 투명하게 하거나, JS에서 조건부 처리 */
    background-color: transparent; /* 드래그 중 배경 클릭 방지 */
    display: flex; /* 이것은 중앙 정렬에 사용되었으나, 이제 JS로 위치를 제어하므로 필요 없을 수 있음 */
    /* justify-content: center; */
    /* align-items: center; */
    z-index: 1000;
}

.modal-content.draggable-modal {
    position: absolute; /* JS에서 left, top으로 위치 제어 */
    background-color: #fff;
    color: #333;
    padding: 0; /* 헤더가 패딩을 갖도록 내부에서 패딩 조정 */
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
    /* 값 입력 칸은 대개 짧다 — 800px 까지 벌릴 이유가 없었다 (2026-09-18) */
    min-width: 360px;
    max-width: 560px;
    max-height: calc(90vh / var(--app-zoom, 1));
    overflow-y: auto;
    cursor: default; /* 기본 커서 */
    /* 초기 중앙 정렬은 JS에서 처리 */
}

/* 어두운 테마 대응 */
[data-theme="dark"] .modal-content.draggable-modal {
    background-color: #2e2e2e;
    color: #e0e0e0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);
}

.modal-header {
    background-color: #f0f0f0; /* 헤더 배경색 */
    color: #333;
    padding: 10px 20px;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    cursor: grab; /* 드래그 가능함을 나타내는 커서 */
    border-bottom: 1px solid #ddd;
}

[data-theme="dark"] .modal-header {
    background-color: #3a3a3a; /* 어두운 테마 헤더 배경 */
    color: #e0e0e0;
    border-bottom: 1px solid #555;
}

.modal-header h2 {
    margin: 0;
    font-size: 1.1em; /* 헤더 내 h2 크기 조정 */
}

/* 헤더에 닫기 버튼 추가 시 (선택적) */
/*
.modal-header .close-button-header {
    float: right;
    background: none;
    border: none;
    font-size: 1.2em;
    cursor: pointer;
    color: #777;
}
[data-theme="dark"] .modal-header .close-button-header {
    color: #bbb;
}
*/

.variables-list {
    padding: 20px; /* 헤더를 제외한 내용 영역 패딩 */
    margin-bottom: 0; /* 하단 버튼과의 간격은 modal-actions에서 처리 */
}

.variable-item {
    display: flex;
    align-items: center;
    margin-bottom: 12px; /* 간격 약간 증가 */
}

.variable-item label {
    margin-right: 8px;
    min-width: 92px;
    text-align: right;
    font-size: 0.9em;
}

.variable-item input[type="text"] {
    flex-grow: 1;
    min-width: 0;
    /* 한 줄 입력에 8px 상하 패딩은 과했다 — 변수가 여럿이면 창이 그만큼 길어진다 */
    padding: 4px 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    color: #333;
}

[data-theme="dark"] .variable-item input[type="text"] {
    background-color: #3a3a3a;
    color: #e0e0e0;
    border: 1px solid #555;
}

.modal-actions {
    display: flex;
    justify-content: flex-end;
    padding: 15px 20px; /* 버튼 영역 패딩 */
    border-top: 1px solid #eee;
}

[data-theme="dark"] .modal-actions {
    border-top: 1px solid #444;
}

.modal-actions button {
    padding: 8px 15px;
    margin-left: 10px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: bold;
}

.modal-actions .submit-button {
    background-color: #007bff;
    color: white;
}

.modal-actions .cancel-button {
    background-color: #6c757d;
    color: white;
}

[data-theme="dark"] .modal-actions .submit-button {
    background-color: #0056b3;
}

[data-theme="dark"] .modal-actions .cancel-button {
    background-color: #545b62;
}

/* 문장별 바인드 변수 표시 스타일 */
/* **높이를 고정한다.** 변수 개수에 따라 창이 커졌다 작아졌다 하면, 같은 자리에 있던 버튼이
   움직여 누르던 곳을 다시 찾아야 한다(신고 2026-09-18). 넘치면 이 안에서 스크롤한다. */
.statements-list {
    padding: 12px 16px;
    height: 300px;
    overflow-y: auto;
}

/* 값이 어떤 타입으로 묶일지 — 입력 오른쪽에 작게 */
.bind-type-badge {
    flex-shrink: 0;
    margin-left: 8px;
    padding: 1px 6px;
    font-size: 10px;
    border-radius: 3px;
    color: var(--color-text-muted, #6b7280);
    background: var(--color-bg-secondary, #f3f4f6);
    border: 1px solid var(--color-border, #e5e7eb);
}

.statement-section {
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 15px;
    margin-bottom: 15px;
    background-color: #f9f9f9;
}

[data-theme="dark"] .statement-section {
    border: 1px solid #555;
    background-color: #2a2a2a;
}

.statement-title {
    margin: 0 0 10px 0;
    font-size: 1.1em;
    color: #007bff;
    font-weight: 600;
}

[data-theme="dark"] .statement-title {
    color: #66b3ff;
}

.statement-preview {
    background-color: #f0f0f0;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px 10px;
    margin-bottom: 12px;
    font-family: 'Courier New', monospace;
    font-size: 0.85em;
    color: #555;
    max-height: 60px;
    overflow-y: auto;
    word-break: break-word;
}

[data-theme="dark"] .statement-preview {
    background-color: #1a1a1a;
    border: 1px solid #444;
    color: #ccc;
}

.statement-section .variables-list {
    padding: 0;
    margin-top: 10px;
}

.statement-section .variable-item {
    margin-bottom: 8px;
}

.statement-section .variable-item label {
    min-width: 80px;
    font-weight: 500;
    color: #007bff;
}

[data-theme="dark"] .statement-section .variable-item label {
    color: #66b3ff;
} 
/* 편집기를 막지 않는다 — 바탕은 눌림을 통과시키고 창만 받는다(값을 편집기에서 복사해 붙여 넣게, 2026-10-26) */
.modal-backdrop.bind-modal-passthrough { pointer-events: none; }
.modal-backdrop.bind-modal-passthrough > .draggable-modal { pointer-events: auto; }
.bind-modal-hint { padding: 6px 16px 0; font-size: 11px; opacity: 0.7; }
.bind-type-select { flex-shrink: 0; font-size: 11px; padding: 2px 4px; border: 1px solid #ccc; border-radius: 4px; background: #fff; color: inherit; }
[data-theme="dark"] .bind-type-select { background: var(--color-input-bg, #252526); border-color: var(--color-input-border, #444); }
`, "",{"version":3,"sources":["webpack://./src/components/BindVariablesModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,2FAA2F;IAC3F,6BAA6B,EAAE,mBAAmB;IAClD,aAAa,EAAE,mDAAmD;IAClE,6BAA6B;IAC7B,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,kBAAkB,EAAE,2BAA2B;IAC/C,sBAAsB;IACtB,WAAW;IACX,UAAU,EAAE,2BAA2B;IACvC,kBAAkB;IAClB,yCAAyC;IACzC,qDAAqD;IACrD,gBAAgB;IAChB,gBAAgB;IAChB,2CAA2C;IAC3C,gBAAgB;IAChB,eAAe,EAAE,UAAU;IAC3B,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,yBAAyB;IACzB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,yBAAyB,EAAE,WAAW;IACtC,WAAW;IACX,kBAAkB;IAClB,2BAA2B;IAC3B,4BAA4B;IAC5B,YAAY,EAAE,qBAAqB;IACnC,6BAA6B;AACjC;;AAEA;IACI,yBAAyB,EAAE,iBAAiB;IAC5C,cAAc;IACd,6BAA6B;AACjC;;AAEA;IACI,SAAS;IACT,gBAAgB,EAAE,kBAAkB;AACxC;;AAEA,yBAAyB;AACzB;;;;;;;;;;;;CAYC;;AAED;IACI,aAAa,EAAE,qBAAqB;IACpC,gBAAgB,EAAE,mCAAmC;AACzD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB,EAAE,aAAa;AACtC;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kDAAkD;IAClD,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB,EAAE,aAAa;IACjC,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,sBAAsB;AACtB;0DAC0D;AAC1D;IACI,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,uCAAuC;IACvC,8CAA8C;IAC9C,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;AACA,uEAAuE;AACvE,yCAAyC,oBAAoB,EAAE;AAC/D,4DAA4D,oBAAoB,EAAE;AAClF,mBAAmB,mBAAmB,EAAE,eAAe,EAAE,YAAY,EAAE;AACvE,oBAAoB,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACrJ,wCAAwC,0CAA0C,EAAE,6CAA6C,EAAE","sourcesContent":[".modal-backdrop {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    /* background-color: rgba(0, 0, 0, 0.5); - 드래그 시 backdrop 클릭 방지를 위해 투명하게 하거나, JS에서 조건부 처리 */\r\n    background-color: transparent; /* 드래그 중 배경 클릭 방지 */\r\n    display: flex; /* 이것은 중앙 정렬에 사용되었으나, 이제 JS로 위치를 제어하므로 필요 없을 수 있음 */\r\n    /* justify-content: center; */\r\n    /* align-items: center; */\r\n    z-index: 1000;\r\n}\r\n\r\n.modal-content.draggable-modal {\r\n    position: absolute; /* JS에서 left, top으로 위치 제어 */\r\n    background-color: #fff;\r\n    color: #333;\r\n    padding: 0; /* 헤더가 패딩을 갖도록 내부에서 패딩 조정 */\r\n    border-radius: 8px;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\r\n    /* 값 입력 칸은 대개 짧다 — 800px 까지 벌릴 이유가 없었다 (2026-09-18) */\r\n    min-width: 360px;\r\n    max-width: 560px;\r\n    max-height: calc(90vh / var(--app-zoom, 1));\r\n    overflow-y: auto;\r\n    cursor: default; /* 기본 커서 */\r\n    /* 초기 중앙 정렬은 JS에서 처리 */\r\n}\r\n\r\n/* 어두운 테마 대응 */\r\n[data-theme=\"dark\"] .modal-content.draggable-modal {\r\n    background-color: #2e2e2e;\r\n    color: #e0e0e0;\r\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.modal-header {\r\n    background-color: #f0f0f0; /* 헤더 배경색 */\r\n    color: #333;\r\n    padding: 10px 20px;\r\n    border-top-left-radius: 8px;\r\n    border-top-right-radius: 8px;\r\n    cursor: grab; /* 드래그 가능함을 나타내는 커서 */\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n[data-theme=\"dark\"] .modal-header {\r\n    background-color: #3a3a3a; /* 어두운 테마 헤더 배경 */\r\n    color: #e0e0e0;\r\n    border-bottom: 1px solid #555;\r\n}\r\n\r\n.modal-header h2 {\r\n    margin: 0;\r\n    font-size: 1.1em; /* 헤더 내 h2 크기 조정 */\r\n}\r\n\r\n/* 헤더에 닫기 버튼 추가 시 (선택적) */\r\n/*\r\n.modal-header .close-button-header {\r\n    float: right;\r\n    background: none;\r\n    border: none;\r\n    font-size: 1.2em;\r\n    cursor: pointer;\r\n    color: #777;\r\n}\r\n[data-theme=\"dark\"] .modal-header .close-button-header {\r\n    color: #bbb;\r\n}\r\n*/\r\n\r\n.variables-list {\r\n    padding: 20px; /* 헤더를 제외한 내용 영역 패딩 */\r\n    margin-bottom: 0; /* 하단 버튼과의 간격은 modal-actions에서 처리 */\r\n}\r\n\r\n.variable-item {\r\n    display: flex;\r\n    align-items: center;\r\n    margin-bottom: 12px; /* 간격 약간 증가 */\r\n}\r\n\r\n.variable-item label {\r\n    margin-right: 8px;\r\n    min-width: 92px;\r\n    text-align: right;\r\n    font-size: 0.9em;\r\n}\r\n\r\n.variable-item input[type=\"text\"] {\r\n    flex-grow: 1;\r\n    min-width: 0;\r\n    /* 한 줄 입력에 8px 상하 패딩은 과했다 — 변수가 여럿이면 창이 그만큼 길어진다 */\r\n    padding: 4px 8px;\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    background-color: #fff;\r\n    color: #333;\r\n}\r\n\r\n[data-theme=\"dark\"] .variable-item input[type=\"text\"] {\r\n    background-color: #3a3a3a;\r\n    color: #e0e0e0;\r\n    border: 1px solid #555;\r\n}\r\n\r\n.modal-actions {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    padding: 15px 20px; /* 버튼 영역 패딩 */\r\n    border-top: 1px solid #eee;\r\n}\r\n\r\n[data-theme=\"dark\"] .modal-actions {\r\n    border-top: 1px solid #444;\r\n}\r\n\r\n.modal-actions button {\r\n    padding: 8px 15px;\r\n    margin-left: 10px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    font-weight: bold;\r\n}\r\n\r\n.modal-actions .submit-button {\r\n    background-color: #007bff;\r\n    color: white;\r\n}\r\n\r\n.modal-actions .cancel-button {\r\n    background-color: #6c757d;\r\n    color: white;\r\n}\r\n\r\n[data-theme=\"dark\"] .modal-actions .submit-button {\r\n    background-color: #0056b3;\r\n}\r\n\r\n[data-theme=\"dark\"] .modal-actions .cancel-button {\r\n    background-color: #545b62;\r\n}\r\n\r\n/* 문장별 바인드 변수 표시 스타일 */\r\n/* **높이를 고정한다.** 변수 개수에 따라 창이 커졌다 작아졌다 하면, 같은 자리에 있던 버튼이\r\n   움직여 누르던 곳을 다시 찾아야 한다(신고 2026-09-18). 넘치면 이 안에서 스크롤한다. */\r\n.statements-list {\r\n    padding: 12px 16px;\r\n    height: 300px;\r\n    overflow-y: auto;\r\n}\r\n\r\n/* 값이 어떤 타입으로 묶일지 — 입력 오른쪽에 작게 */\r\n.bind-type-badge {\r\n    flex-shrink: 0;\r\n    margin-left: 8px;\r\n    padding: 1px 6px;\r\n    font-size: 10px;\r\n    border-radius: 3px;\r\n    color: var(--color-text-muted, #6b7280);\r\n    background: var(--color-bg-secondary, #f3f4f6);\r\n    border: 1px solid var(--color-border, #e5e7eb);\r\n}\r\n\r\n.statement-section {\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 6px;\r\n    padding: 15px;\r\n    margin-bottom: 15px;\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n[data-theme=\"dark\"] .statement-section {\r\n    border: 1px solid #555;\r\n    background-color: #2a2a2a;\r\n}\r\n\r\n.statement-title {\r\n    margin: 0 0 10px 0;\r\n    font-size: 1.1em;\r\n    color: #007bff;\r\n    font-weight: 600;\r\n}\r\n\r\n[data-theme=\"dark\"] .statement-title {\r\n    color: #66b3ff;\r\n}\r\n\r\n.statement-preview {\r\n    background-color: #f0f0f0;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    padding: 8px 10px;\r\n    margin-bottom: 12px;\r\n    font-family: 'Courier New', monospace;\r\n    font-size: 0.85em;\r\n    color: #555;\r\n    max-height: 60px;\r\n    overflow-y: auto;\r\n    word-break: break-word;\r\n}\r\n\r\n[data-theme=\"dark\"] .statement-preview {\r\n    background-color: #1a1a1a;\r\n    border: 1px solid #444;\r\n    color: #ccc;\r\n}\r\n\r\n.statement-section .variables-list {\r\n    padding: 0;\r\n    margin-top: 10px;\r\n}\r\n\r\n.statement-section .variable-item {\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.statement-section .variable-item label {\r\n    min-width: 80px;\r\n    font-weight: 500;\r\n    color: #007bff;\r\n}\r\n\r\n[data-theme=\"dark\"] .statement-section .variable-item label {\r\n    color: #66b3ff;\r\n} \r\n/* 편집기를 막지 않는다 — 바탕은 눌림을 통과시키고 창만 받는다(값을 편집기에서 복사해 붙여 넣게, 2026-10-26) */\r\n.modal-backdrop.bind-modal-passthrough { pointer-events: none; }\r\n.modal-backdrop.bind-modal-passthrough > .draggable-modal { pointer-events: auto; }\r\n.bind-modal-hint { padding: 6px 16px 0; font-size: 11px; opacity: 0.7; }\r\n.bind-type-select { flex-shrink: 0; font-size: 11px; padding: 2px 4px; border: 1px solid #ccc; border-radius: 4px; background: #fff; color: inherit; }\r\n[data-theme=\"dark\"] .bind-type-select { background: var(--color-input-bg, #252526); border-color: var(--color-input-border, #444); }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
